const BaseUrl =
"https://panel.whitelabelmd.com/nextvial/api/";
// const BaseUrl=
// "https://lightgoldenrodyellow-okapi-586794.hostingersite.com/nextvial/api/";

export const products_url = BaseUrl + "get_products";
export const cheke_state = BaseUrl + "cheke_state";
export const add_user_check_product = BaseUrl + "createOrder_test";
export const createOrder_test_new = BaseUrl + "createOrder_test";
export const contact_details_step_25 = BaseUrl + "contact_details_step_25";
export const get_checkout_link_data = BaseUrl + "get_checkout_link_data";
export const get_product_details = BaseUrl + "get_product_details";
export const get_product_details_v3 = BaseUrl + "get_product_details_v3";
export const get_url_data = BaseUrl + "get_url_data";
export const createOrder_test = BaseUrl + "createOrder_test";
export const createOrder_test_2345 = BaseUrl + "createOrder_test";
export const check_coupons = BaseUrl + "check_coupons";
export const check_coupons_v3 =
  "https://panel.whitelabelmd.com/wlmdbackend/api/check_coupons_v3";
export const member_view = BaseUrl + "member_view";
export const create_payment_intent = BaseUrl + "stripe/create-payment-intent";
/** Use when backend adds a live-only route; set REACT_APP_CREATE_PAYMENT_INTENT_URL to override */
export const create_payment_intent_live =
  BaseUrl + "stripe/create-payment-intent-live";
export const createOrder_stripe = BaseUrl + "createOrder_stripe";